/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyMobileApp
 */
export interface WriteOnlyMobileApp {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMobileApp
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMobileApp
     */
    link: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMobileApp
     */
    packageName: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMobileApp
     */
    appName: string;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyMobileApp
     */
    versionName: string;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyMobileApp
     */
    versionCode: number;
}

export function WriteOnlyMobileAppFromJSON(json: any): WriteOnlyMobileApp {
    return WriteOnlyMobileAppFromJSONTyped(json, false);
}

export function WriteOnlyMobileAppFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyMobileApp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'link': json['link'],
        'packageName': json['package_name'],
        'appName': json['app_name'],
        'versionName': json['version_name'],
        'versionCode': json['version_code'],
    };
}

export function WriteOnlyMobileAppToJSON(value?: WriteOnlyMobileApp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'link': value.link,
        'package_name': value.packageName,
        'app_name': value.appName,
        'version_name': value.versionName,
        'version_code': value.versionCode,
    };
}


